import { Box, Chip, Stack, Typography } from "@mui/material";

export default function DashboardHeader(props) {
    const { title, subtitle, tags = [], sx } = props;

    return (
        <Box sx={{ ...sx }}>
            <Typography variant="h1" sx={{ fontSize: "2em", fontWeight: "bold" }}>
                {title}
            </Typography>
            <Typography variant="h2" sx={{ fontSize: "1.2em" }}>
                {subtitle}
            </Typography>
            <Stack direction="row" spacing={0.5} sx={{ marginTop: 1 }}>
                {tags.map((tag, index) => (
                    <Chip key={index} label={tag} size="small" />
                ))}
            </Stack>
        </Box>
    );
}
